import React, {FC, HTMLAttributes} from 'react';
import css from './EmailCircle.module.scss';
import emailLogo from '../../assets/unsubscribe/icons/email.svg'
import classNames from 'classnames/bind';

const cx = classNames.bind(css);

const EmailCircle: FC<HTMLAttributes<HTMLDivElement>> = ({className}) => {
    return (
        <div className={cx(css.circle, className)}>
            <img className={css.circle__logo} src={emailLogo} alt="email_logo"/>
        </div>
    );
};

export default EmailCircle;